<template>
  <div v-loading.fullscreen.lock="true" element-loading-text="绑定中正在跳转..." />
</template>
<script>
export default {
  name: 'BindWechat',
  data() {
    return {
      loginTypeId: 0,
    }
  },
  mounted() {
    var path = window.location.href
    if (path.indexOf('code') >= 0) {
      // 如果url中包含code,则保存到store中
      let code = path.split('?')[1]
      code = code.substring(5, code.indexOf('&'))
      let params = {
        code: code,
      }
      this.$http
        .bind_wx(params)
        .then(res => {
          this.$toast('绑定成功！')
          this.$store.dispatch('getMyInfo')
          this.$router.push({ path: '/user' })
        })
        .catch(response => {
          this.$store.dispatch('getMyInfo')
          this.$router.push({ path: '/user' })
        })
    }
  },
  methods: {},
}
</script>
